import React from 'react';

const VARIANTS = {
  product: {
    href: '/Forsyt-Product-Overview.pdf',
    filename: 'Forsyt-Product-Overview.pdf',
    event: 'pdf_download',
  },
  security: {
    href: '/Forsyt-Security-Overview.pdf',
    filename: 'Forsyt-Security-Overview.pdf',
    event: 'security_pdf_download',
  },
  metricstream: {
    href: '/Forsyt-for-MetricStream.pdf',
    filename: 'Forsyt-for-MetricStream.pdf',
    event: 'metricstream_pdf_download',
  },
  epiplex: {
    href: '/Forsyt-for-Epiplex.pdf',
    filename: 'Forsyt-for-Epiplex.pdf',
    event: 'epiplex_pdf_download',
  },
  moengage: {
    href: '/Forsyt-for-MoEngage.pdf',
    filename: 'Forsyt-for-MoEngage.pdf',
    event: 'moengage_pdf_download',
  },
  goaudit: {
    href: '/Forsyt-for-GoAudit.pdf',
    filename: 'Forsyt-for-GoAudit.pdf',
    event: 'goaudit_pdf_download',
  },
  mci: {
    href: '/Forsyt-for-MCI.pdf',
    filename: 'Forsyt-for-MCI.pdf',
    event: 'mci_pdf_download',
  },
};

/**
 * Fire-and-forget analytics ping. Never blocks the download, even if the
 * backend is down or slow, the browser begins the file download immediately.
 */
function pingDownload(event, source) {
  try {
    const base = process.env.REACT_APP_BACKEND_URL || '';
    const url = `${base}/api/events/track`;
    const body = JSON.stringify({ event_type: event, page: source });
    if (navigator.sendBeacon) {
      const blob = new Blob([body], { type: 'application/json' });
      navigator.sendBeacon(url, blob);
      return;
    }
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body,
      keepalive: true,
    }).catch(() => {});
  } catch {
    /* swallow, analytics must never block download */
  }
}

/**
 * Drop-in <a> that downloads a Forsyt PDF and pings analytics.
 *
 * Usage:
 *   <PDFDownloadLink source="header" className="...">Download PDF</PDFDownloadLink>
 *   <PDFDownloadLink variant="security" source="security-page" className="...">Security PDF</PDFDownloadLink>
 */
const PDFDownloadLink = ({ source, variant = 'product', className, children, onClick, ...rest }) => {
  const cfg = VARIANTS[variant] || VARIANTS.product;
  return (
    <a
      href={cfg.href}
      download={cfg.filename}
      onClick={(e) => {
        pingDownload(cfg.event, source);
        if (onClick) onClick(e);
      }}
      className={className}
      data-testid={`pdf-download-${variant}-${source}`}
      {...rest}
    >
      {children}
    </a>
  );
};

export default PDFDownloadLink;
